import InputBox from "../../../../../common/interactive/InputBox";
import classes from './PreviousCareRepeaterItem.module.css'

export default function PreviousCareRepeaterItem({addItemData, id, itemData}) {

    function addNewItemHandler(value) {
        if (addItemData) {
            addItemData(value)
        }
    }
    
    return <div className={classes.item}>
        <InputBox label={'Name'} currentValue={itemData.care_repeater_name} action={addNewItemHandler} identifier={{type: null, field: 'care_repeater_name', type_id: null, folder: null, repeater_id: id}} />
        <InputBox label={'Phone'} currentValue={itemData.care_repeater_phone} action={addNewItemHandler} name={'phone'} required={true} format={'phone'} identifier={{type: null, field: 'care_repeater_phone', type_id: null, folder: null, repeater_id: id}} />
        <InputBox label={'Fax'} currentValue={itemData.care_repeater_fax} action={addNewItemHandler} name={'fax'} format={'phone'} identifier={{type: null, field: 'care_repeater_fax', type_id: null, folder: null, repeater_id: id}} />       
        
    </div>
}